import type { ReactNode } from 'react'
import { Database } from 'lucide-react'
import { useDemoDataSettings } from '@/context/DemoDataContext'
import type { PlatformModuleId } from '@/types'

export function DemoEmptyState({
  moduleId,
  title,
  description,
  children,
}: {
  moduleId: PlatformModuleId
  title: string
  description?: string
  children?: ReactNode
}) {
  const { isModuleDemoEnabled, loading } = useDemoDataSettings()

  if (loading) {
    return <div className="p-6 text-[12px] text-stone-500">Loading workspace…</div>
  }

  if (isModuleDemoEnabled(moduleId)) {
    return <>{children}</>
  }

  return (
    <div className="flex h-full min-h-[320px] flex-col items-center justify-center gap-3 p-8 text-center">
      <Database size={28} className="text-amber-300/80" />
      <div className="text-[15px] font-medium text-stone-100">{title}</div>
      <p className="max-w-md text-[12px] leading-relaxed text-stone-500">
        {description ?? 'Demo data is off for this module. Add your live data to begin working in this workspace.'}
      </p>
    </div>
  )
}
